export const AUTH_LOGIN_IN_PROGRESS = "AUTH_LOGIN_IN_PROGRESS";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_ERROR = "AUTH_LOGIN_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_GET_USER_IN_PROGRESS = "AUTH_GET_USER_IN_PROGRESS";
export const AUTH_GET_USER_SUCCESS = "AUTH_GET_USER_SUCCESS";
export const AUTH_GET_USER_ERROR = "AUTH_GET_USER_ERROR";
export const AUTH_REFRESH_IN_PROGRESS = "AUTH_REFRESH_IN_PROGRESS";
export const AUTH_REFRESH_SUCCESS = "AUTH_REFRESH_SUCCESS";
export const AUTH_REFRESH_ERROR = "AUTH_REFRESH_ERROR";
